/**
 * Unified scroll-snap slider with arrow navigation.
 * Use with: [data-scroll-snap-slider] on the scroll container, [data-slider-prev] / [data-slider-next] on buttons.
 * Slide selector is configurable via data-slide-selector (default: direct children).
 * Arrows are hidden and disabled at start/end (same behavior as product media).
 */
(function () {
  const SCROLL_EDGE_THRESHOLD = 2;
  const DISABLED_CLASS = 'slider-arrows__btn--disabled';

  function updateArrowState(track, prevBtn, nextBtn) {
    const scrollLeft = track.scrollLeft;
    const maxScroll = track.scrollWidth - track.clientWidth;
    const atStart = scrollLeft <= SCROLL_EDGE_THRESHOLD;
    const atEnd = maxScroll <= SCROLL_EDGE_THRESHOLD || scrollLeft >= maxScroll - SCROLL_EDGE_THRESHOLD;

    if (prevBtn) {
      if (atStart) {
        prevBtn.classList.add(DISABLED_CLASS);
        prevBtn.setAttribute('aria-disabled', 'true');
        prevBtn.disabled = true;
      } else {
        prevBtn.classList.remove(DISABLED_CLASS);
        prevBtn.removeAttribute('aria-disabled');
        prevBtn.disabled = false;
      }
    }
    if (nextBtn) {
      if (atEnd) {
        nextBtn.classList.add(DISABLED_CLASS);
        nextBtn.setAttribute('aria-disabled', 'true');
        nextBtn.disabled = true;
      } else {
        nextBtn.classList.remove(DISABLED_CLASS);
        nextBtn.removeAttribute('aria-disabled');
        nextBtn.disabled = false;
      }
    }
  }

  function initScrollSnapSliders() {
    document.querySelectorAll('[data-scroll-snap-slider]').forEach((track) => {
      const id = track.id || track.dataset.sliderId;
      if (!id) return;
      if (track._scrollSnapInitialized) return;
      track._scrollSnapInitialized = true;

      const slideSelector = track.dataset.slideSelector || '> *';
      const section = track.closest('[id^="shopify-section-"]');
      const scope = section || document;
      const prevBtn = scope.querySelector(`[data-slider-prev="${id}"]`);
      const nextBtn = scope.querySelector(`[data-slider-next="${id}"]`);

      function scroll(direction) {
        const slides = track.querySelectorAll(slideSelector);
        if (slides.length === 0) return;
        const slideWidth = slides[0].offsetWidth;
        const gap = getComputedStyle(track).gap;
        const gapNum = gap ? parseInt(gap, 10) || 0 : 0;
        const scrollAmount = slideWidth + gapNum;
        track.scrollBy({
          left: direction === 'prev' ? -scrollAmount : scrollAmount,
          behavior: 'smooth',
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => scroll('prev'));
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => scroll('next'));
      }

      function onScrollOrResize() {
        updateArrowState(track, prevBtn, nextBtn);
      }

      updateArrowState(track, prevBtn, nextBtn);
      track.addEventListener('scroll', onScrollOrResize);
      window.addEventListener('resize', onScrollOrResize);
    });
  }

  function resetOnSectionLoad() {
    document.querySelectorAll('[data-scroll-snap-slider]').forEach((track) => {
      delete track._scrollSnapInitialized;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollSnapSliders);
  } else {
    initScrollSnapSliders();
  }

  document.addEventListener('shopify:section:load', () => {
    resetOnSectionLoad();
    initScrollSnapSliders();
  });
})();
